import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export const ANIMATION_DURATION = 2000;

const styles = css`
  & {
    svg {
      color: ${theme.colors.NEUTRAL600};
    }
  }
  &.copy-link {
    border: 0;
    padding: 0;
    background: none;
    outline: none;
    cursor: pointer;
  }
`;

export default styles;
